import Backbone from "backbone";
import Capture from "../Capture";


let CamPhotoModel = Backbone.Model.extend("CamPhotoModel", {
    defaults: {
        src: ""
    },

    remove() {
        this.collection.remove(this);
    },

    toCapture() {
        return new Capture(this.attributes);
    }
});

export default CamPhotoModel;
